export default {
  contractSectionLineItems: [],
  contractSectionLineItem: undefined,
};
